import React from 'react';

/**
 * Subtitle component for categories in tier
 * @component
 * @returns
 */
export const SubTitle = ({ children, ...props }) => {
  return <h4 { ...props }>{ children }</h4>;
};